import { useVariantsByIds } from "~/hooks/useVariants"
import { sumBy } from "~/utils/tsUtils"
import { useForecasts } from "~/hooks/useForecasts"
import {
  getStartOfCurrentWeekUTC,
  getStartOfFullMonthDatesBetween,
  getStartOfWeekDatesBetween,
} from "~/utils/datetime"
import { sum } from "lodash"

import { addWeeks } from "date-fns"

export default function useSafetyStockSeries(
  startDate: Date,
  endDate: Date,
  monthly: boolean,
  variantIds: string[],
  warehouseId: string | undefined,
) {
  const dates = monthly
    ? getStartOfFullMonthDatesBetween(startDate, endDate)
    : getStartOfWeekDatesBetween(startDate, endDate)
  const variants = useVariantsByIds(variantIds)
  const weekCoverVariants = variants.filter((v) => v.settings.bufferType === "weekCover")
  const otherBuffers = sumBy(
    variants
      .filter((v) => v.settings.bufferType !== "weekCover")
      .flatMap((v) => v.outOfStockInformation)
      .filter((info) => info.buffer != null),
    "buffer",
  )
  const { getForecastsBetweenDates } = useForecasts()
  const minDate = getStartOfCurrentWeekUTC()
  const warehouses = warehouseId ? [warehouseId] : undefined

  return dates.map((date) => {
    const baseDate = date < minDate ? minDate : date

    return {
      date,
      quantity:
        sum(
          weekCoverVariants.map((v) =>
            getForecastsBetweenDates(
              v.variantId,
              warehouses,
              baseDate,
              addWeeks(baseDate, Number(v.settings.bufferValue)),
            ),
          ),
        ) + otherBuffers,
    }
  })
}
